<template>
    <div class="field">
        <label v-if="label">{{ label }}</label>

        <div class="control">
            <textarea
                :name="name"
                :value="value"
                v-bind="$attrs"
                v-validate="validate"
                :class="['textarea', {'is-danger': errors.has(name)}]"
                @input="$emit('input', $event.target.value)">}}</textarea>
        </div>

        <p class="help is-danger">{{ errors.first(name) }}</p>
    </div>
</template>

<script>
export default {
    name: 'Input',
    inheritAttrs: false,
    props: ['name', 'value', 'validate', 'label'],
    inject: ['$validator'],
};
</script>
